import {
  Box,
  Divider,
  Heading,
  ListItem,
  OrderedList,
  Text,
  useColorModeValue,
} from "@chakra-ui/react"
import { createFileRoute } from "@tanstack/react-router"
import { WmsPageHeader } from "../../../../components/WMS/shared/WmsPageHeader"
import {
  WmsPagePanel,
  WmsPageShell,
} from "../../../../components/WMS/shared/WmsPageShell"

export const Route = createFileRoute(
  "/_layout/WMS/inventory-count/instructions-operator",
)({
  component: InventoryCountOperatorInstructionsPage,
})

function InventoryCountOperatorInstructionsPage() {
  const panelBg = useColorModeValue("white", "gray.800")
  const panelBorder = useColorModeValue("gray.200", "whiteAlpha.200")
  const mutedText = useColorModeValue("gray.600", "gray.300")

  return (
    <WmsPageShell>
      <WmsPageHeader
        title="Instrukcja: Operator inwentaryzacji"
        description="Krok po kroku, jak wykonać zadanie inwentaryzacyjne."
        gradient="linear(to-r, teal.600, blue.600)"
        badge="Operator"
      />

      <WmsPagePanel bg={panelBg} borderColor={panelBorder}>
        <Box flex="1" minH={0} overflowY="auto" pr={1}>
          <Box>
            <Heading size="sm" mb={3}>
              Przed rozpoczęciem
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>Otwórz sekcję: /WMS/inventory-count/tasks.</ListItem>
              <ListItem>Włącz filtr „Moje zadania”.</ListItem>
              <ListItem>
                Upewnij się, że zadanie ma status „open” albo „in_progress”.
              </ListItem>
            </OrderedList>
          </Box>

          <Divider my={5} />

          <Box>
            <Heading size="sm" mb={3}>
              Wykonanie liczenia
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>
                Jeśli status to „open”, kliknij „Rozpocznij” (status zmieni się
                na „in_progress”).
              </ListItem>
              <ListItem>Otwórz zadanie przyciskiem „Otwórz”.</ListItem>
              <ListItem>
                Dla każdego wiersza wpisz rzeczywistą ilość w polu „Policzona
                ilość”.
              </ListItem>
              <ListItem>
                Używaj Entera lub skanera, aby przejść do następnego wiersza.
              </ListItem>
              <ListItem>Klikaj „Zapisz”, aby zapisać wynik pośredni.</ListItem>
            </OrderedList>
          </Box>

          <Divider my={5} />

          <Box>
            <Heading size="sm" mb={3}>
              Zakończenie
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>
                Sprawdź, czy nie zostały błędy: puste pole, wartość nieliczbowa
                albo ujemna.
              </ListItem>
              <ListItem>Kliknij „Wyślij do weryfikacji”.</ListItem>
              <ListItem>
                Upewnij się, że status zmienił się na „pending_review” (albo
                „approved”, jeśli polityka pozwala na automatyczne
                zatwierdzenie).
              </ListItem>
            </OrderedList>
          </Box>

          <Divider my={5} />

          <Box>
            <Heading size="sm" mb={3}>
              Jeśli pojawił się problem
            </Heading>
            <OrderedList spacing={2} pl={5}>
              <ListItem>
                403 insufficient permissions: skontaktuj się z administratorem w
                sprawie uprawnienia wms.inventory_count.task.execute.
              </ListItem>
              <ListItem>
                Błąd blokady lokacji: tę lokację liczy już inne aktywne zadanie.
              </ListItem>
              <ListItem>
                Przy dużej rozbieżności nie wymuszaj potwierdzenia, zgłoś to
                supervisorowi.
              </ListItem>
            </OrderedList>
          </Box>

          <Text fontSize="sm" color={mutedText} mt={6}>
            Szybka ścieżka: /WMS/inventory-count/tasks
          </Text>
        </Box>
      </WmsPagePanel>
    </WmsPageShell>
  )
}
